import { useIntlModule } from 'utils/intl';
import messages from './spendSettings.intl.json';

export function useSpendSettingsIntl() {
  return useIntlModule(messages);
}
